module.exports = __webpack_public_path__ + "static/media/parking-circle.53728ce9.svg";